import React from 'react';
import { motion } from 'framer-motion';
import PricingCard from './PricingCard';

const plans = [
  {
    name: 'Essentials',
    description: 'Perfect for individuals and small teams getting started.',
    price: 99,
    features: [
      'Recording Keeping',
      'Basic support',
      'Inspections',
      'Basic Analysis',
      'Email notifications',
    ],
  },
  {
    name: 'Pro',
    description: 'For growing teams needing more power and flexibility. ESSENTIALS PLUS:',
    price: 299,
    features: [
      'Compliance',
      'Real Time',
      'Analytics and Reporting',
      'Training Records',
      'Inspection',
      'Paperwork',
    ],
  },
  {
    name: 'Enterprise',
    description: 'Tailored solutions for large organizations. PRO PLUS:',
    price: 'Custom',
    features: [
      'Costomized Solution',
      'AI Report',
      'Analytics and Reporting',
      'Training Records',
      'Inspection',
      '24/7 Customer Service',
    ],
  },
];

const Safetysoftware = () => {
  return (
    <section id="safetysoftware" className="py-5 bg-gradient-to-br from-gray-50 to-white scroll-mt-40">
      <div className="">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-6xl font-extrabold text-gray-900 mb-6 bg-clip-text text-transparent bg-gradient-to-r from-orange-600 to-amber-500">
              Simple, Workforce Platform
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Find the perfect plan that fits your needs and helps you achieve your goals. No hidden fees, just pure value.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {plans.map((plan, index) => (
              <motion.div
                key={plan.name}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <PricingCard plan={plan} isPopular={plan.name === 'Pro'} />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Safetysoftware;